import { render, staticRenderFns } from "./DocumentsToSend.vue?vue&type=template&id=2202c493&scoped=true&"
import script from "./DocumentsToSend.vue?vue&type=script&lang=js&"
export * from "./DocumentsToSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2202c493",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VCard,VSnackbar})
